import { lazy } from 'react';

/**
 * The two import review modals, split out of the main bundle.
 *
 * Between them they're ~214 kB of source — parsers, review tables, per-item
 * editors — and neither can appear without an explicit user action (choosing a
 * file, or opening a forwarded-email import from a notification). Most
 * sessions never open either, so they don't belong in the initial download.
 *
 * Deliberately re-exported under their original names: call sites keep writing
 * `<ImportBookingModal>` / `<ImportItineraryModal>`, which keeps the JSX
 * readable and keeps `itineraryImportHost.test.ts` — which asserts on the
 * itinerary modal's element identity by tag name — still pointing at the
 * thing it's meant to guard.
 *
 * Each call site supplies its own `<Suspense>`. It belongs *outside* the
 * surrounding `<AnimatePresence>`: AnimatePresence tracks its direct children
 * to run exit animations, so slipping a Suspense boundary in between would
 * silently break the modal's close animation.
 */
export const ImportBookingModal = lazy(() =>
  import('./ImportBookingModal').then(m => ({ default: m.ImportBookingModal })),
);

export const ImportItineraryModal = lazy(() =>
  import('./ImportItineraryModal').then(m => ({ default: m.ImportItineraryModal })),
);

/**
 * Expenses and Memories tabs: only App imports them and neither is the landing
 * tab, so they load on first visit (the service worker has already precached
 * the chunk). App wraps the tab area in its own <Suspense>.
 */
export const ExpensesTab = lazy(() => import('./Expenses').then(m => ({ default: m.ExpensesTab })));
export const LinkedExpenseItem = lazy(() => import('./Expenses').then(m => ({ default: m.ExpenseItem })));
export const MemoriesTab = lazy(() => import('./Memories').then(m => ({ default: m.MemoriesTab })));
